import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Image, Container, Form, Button, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./abt-yourself.css";

import backarrow from "../../../assets/images/backarrow.jpg";
import logo2 from "../../../assets/images/logo2.png";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from "../Stepper";
import log from "../../../utils/log";
import * as userActions from "../../../actions/user";
import * as userPreferencesActions from "../../../actions/userPreferences";

import { useCookies } from "../../../hooks/useCookies";

export const AbtYourself = () => {
  const navigate = useNavigate();
  const isFetched = useRef(false);

  const { getCookie } = useCookies();
  const token = getCookie("token");

  const [loading, setLoading] = useState(false);
  const [havegender, setHavegender] = useState(0);
  const [wantGender, setWantGender] = useState(0);
  const [haveerrorMessage, setHaveErrorMessage] = useState("");
  const [wanthaveerrorMessage, setWantHaveErrorMessage] = useState("");
  const [femaleActive, setFemaleActive] = useState(false);
  const [maleActive, setMaleActive] = useState(false);
  const [nonBinaryActive, setNonBinaryActive] = useState(false);
  const [femaleSvgColor, setFemaleSvgColor] = useState("#AAAAAA");
  const [maleSvgColor, setMaleSvgColor] = useState("#AAAAAA");
  const [nonBinarySvgColor, setNonBinarySvgColor] = useState("#AAAAAA");
  const [selectedOption, setSelectedOption] = useState(null);

  const handleFemaleButtonClick = () => {
    setFemaleActive(true);
    setMaleActive(false);
    setNonBinaryActive(false);
    setFemaleSvgColor("#FC8C66");
    setMaleSvgColor("#AAAAAA");
    setNonBinarySvgColor("#AAAAAA");
    setHavegender(2);
  };

  const handleMaleButtonClick = () => {
    setFemaleActive(false);
    setMaleActive(true);
    setNonBinaryActive(false);
    setFemaleSvgColor("#AAAAAA");
    setMaleSvgColor("#FC8C66");
    setNonBinarySvgColor("#AAAAAA");
    setHavegender(1);
  };

  const handleNonBinaryButtonClick = () => {
    setFemaleActive(false);
    setMaleActive(false);
    setNonBinaryActive(true);
    setFemaleSvgColor("#AAAAAA");
    setMaleSvgColor("#AAAAAA");
    setNonBinarySvgColor("#FC8C66");
    setHavegender(3);
  };

  const handlePrefer = option => {
    setSelectedOption(option);
    const wantGender = option === "female" ? 2 : option === "male" ? 1 : 3;
    setWantGender(wantGender);
  };

  const updatePreferences = async wantGender => {
    try {
      await userPreferencesActions.updateGender(
        JSON.stringify({
          value: wantGender,
        })
      );
    } catch (error) {
      log.error(error);
    }
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setHaveErrorMessage("");
    setWantHaveErrorMessage("");

    // Validate user input
    if (!havegender) {
      setHaveErrorMessage("*Please make a selection.");
      return;
    }
    if (!wantGender) {
      setWantHaveErrorMessage("*Please make a selection.");
      return;
    }

    setLoading(true);
    try {
      await updatePreferences(wantGender);
      await userActions.updateUserGender(
        JSON.stringify({
          gender: havegender,
          want_gender: wantGender,
        })
      );
      navigate("/selfie");
    } catch (error) {
      log.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isFetched.current) return; // Prevent multiple API calls
    isFetched.current = true;

    if (!token) return;
    fetchData();
  }, [token, handleMaleButtonClick, havegender, selectedOption]);

  const fetchData = async () => {
    try {
      const response = await userActions.getUserGender();
      const { gender, want_gender } = response;

      setHavegender(gender);
      setWantGender(want_gender);

      if (gender === 1) {
        handleMaleButtonClick();
      } else if (gender === 2) {
        handleFemaleButtonClick();
      } else if (gender === 3) {
        handleNonBinaryButtonClick();
      }

      if (want_gender === 1) {
        setSelectedOption("male");
      } else if (want_gender === 2) {
        setSelectedOption("female");
      } else if (want_gender === 3) {
        setSelectedOption("all");
      }
    } catch (error) {
      log.error("Error fetching user data:", error);
    }
  };

  return (
    <div className="birthday-container">
      <div className="birthday-bg">
        <Image className="responsive-bg" src={responsivebg}></Image>
      </div>
      <Container className="birthday-main">
        <Container className="birthday-content">
          <Container className="logo-progressbar5">
            <Container className="logo-arrow5">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
              />
              <Image
                src={logo2}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
          </Container>
          <Stepper activeStep="AboutYourSelf" />
          <Container className="birthday-details">
            <p className="birthday-label">What’s your gender?</p>
            <Form className="birthday-form" onSubmit={handleSubmit}>
              <Form.Group controlId="formgender" className="birthday-group">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginBottom: "24px",
                    justifyContent: "space-around",
                  }}
                >
                  <div className="gender-name">
                    <Button
                      className={`gender-btn ${femaleActive ? "active" : ""}`}
                      onClick={handleFemaleButtonClick}
                    >
                      <svg
                        width="34"
                        height="48"
                        viewBox="0 0 34 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="17.0007"
                          cy="16.6667"
                          r="14.6667"
                          stroke={femaleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0003 31.3359V46.0026V31.3359Z"
                          fill="white"
                        />
                        <path
                          d="M17.0003 31.3359V46.0026"
                          stroke={femaleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.85352 39.4847H25.1498H8.85352Z"
                          fill="white"
                        />
                        <path
                          d="M8.85352 39.4847H25.1498"
                          stroke={femaleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Button>
                    <span>Woman</span>
                  </div>
                  <div className="gender-name">
                    <Button
                      className={`gender-btn ${maleActive ? "active" : ""}`}
                      onClick={handleMaleButtonClick}
                    >
                      <svg
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="15.3041"
                          cy="22.6947"
                          r="13.3041"
                          stroke={maleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M24.709 13.29L35.999 2"
                          stroke={maleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M27.1309 2H36.0003V10.8694"
                          stroke={maleSvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Button>
                    <span>Man</span>
                  </div>
                  <div className="gender-name">
                    <Button
                      className={`gender-btn ${nonBinaryActive ? "active" : ""
                        }`}
                      onClick={handleNonBinaryButtonClick}
                    >
                      <svg
                        width="32"
                        height="44"
                        viewBox="0 0 32 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <ellipse
                          cx="13.3205"
                          cy="18.1537"
                          rx="11.4846"
                          ry="11.5366"
                          stroke={nonBinarySvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.3203 29.6875V41.9932V29.6875Z"
                          fill="white"
                        />
                        <path
                          d="M13.3203 29.6875V41.9932"
                          stroke={nonBinarySvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.19531 36.6118H19.4455H7.19531Z"
                          fill="white"
                        />
                        <path
                          d="M7.19531 36.6118H19.4455"
                          stroke={nonBinarySvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M22.5078 2H30.1642V9.69104"
                          fill="white"
                        />
                        <path
                          d="M22.5078 2H30.1642V9.69104"
                          stroke={nonBinarySvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M21.8203 10.3832L30.1658 2L21.8203 10.3832Z"
                          fill="white"
                        />
                        <path
                          d="M21.8203 10.3832L30.1658 2"
                          stroke={nonBinarySvgColor}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Button>
                    <span>Non-Binary</span>
                  </div>
                </div>
                <div style={{ marginTop: "-15px" }}>
                  {haveerrorMessage && (
                    <Form.Text className="text-danger error-message">
                      {haveerrorMessage}
                    </Form.Text>
                  )}
                </div>
              </Form.Group>

              <Form.Group
                controlId="formgender"
                className="birthday-group"
                style={{ marginTop: "30px" }}
              >
                <Form.Label className="birthday-label">
                  Who do you want to date?
                </Form.Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-around",
                  }}
                >
                  <Button
                    className="prefer-whome"
                    onClick={() => handlePrefer("female")}
                    style={{
                      background:
                        selectedOption === "female"
                          ? "linear-gradient(180deg, #fc8c66 -4.17%, #f76a7b 110.42%)"
                          : "transparent",
                      fontFamily: '"Inter"',
                      fontSize: "16px",
                      fontWeight: "500",
                      color: selectedOption === "female" ? "white" : "#515151",
                      lineHeight: "24px",
                      letterSpacing: "0.04em",
                      border:
                        selectedOption === "female"
                          ? "none"
                          : "1px solid #6C6C6C ",
                    }}
                  >
                    Women
                  </Button>
                  <Button
                    className="prefer-whome"
                    onClick={() => handlePrefer("male")}
                    style={{
                      background:
                        selectedOption === "male"
                          ? "linear-gradient(180deg, #fc8c66 -4.17%, #f76a7b 110.42%)"
                          : "transparent",
                      fontFamily: '"Inter"',
                      fontSize: "16px",
                      fontWeight: "500",
                      color: selectedOption === "male" ? "white" : "#515151",
                      lineHeight: "24px",
                      letterSpacing: "0.04em",
                      border:
                        selectedOption === "male"
                          ? "none"
                          : "1px solid #6C6C6C ",
                    }}
                  >
                    Men
                  </Button>
                  <Button
                    className="prefer-whome"
                    onClick={() => handlePrefer("all")}
                    style={{
                      background:
                        selectedOption === "all"
                          ? "linear-gradient(180deg, #fc8c66 -4.17%, #f76a7b 110.42%)"
                          : "transparent",
                      fontFamily: '"Inter"',
                      fontSize: "16px",
                      fontWeight: "500",
                      color: selectedOption === "all" ? "white" : "#515151",
                      lineHeight: "24px",
                      letterSpacing: "0.04em",
                      border:
                        selectedOption === "all"
                          ? "none"
                          : "1px solid #6C6C6C ",
                    }}
                  >
                    All
                  </Button>
                </div>
                <div style={{ marginTop: "5px" }}>
                  {wanthaveerrorMessage && (
                    <Form.Text className="text-danger error-message">
                      {wanthaveerrorMessage}
                    </Form.Text>
                  )}
                </div>
              </Form.Group>
                <div   className="d-flex justify-content-center"
                  style={{
                    position: "fixed",
                    bottom: "30px",
                    width: "100%",
                    gap: "30px",
                  }}>
                  <button
                    type="submit"
                    className="global-next-bottom-fix-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" role="status" />
                    ) : (
                      "Next"
                    )}
                  </button>
                </div>
            </Form>
          </Container>
        </Container>
      </Container>
    </div>
  );
};
